import React from 'react';

export function TwitterIcon(props: React.SVGProps<SVGSVGElement>) {
  const { className, ...rest } = props;
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M11.3333 8.92873L16.5459 3H15.3111L10.7831 8.14678L7.1692 3H3L8.46607 10.7836L3 17H4.2348L9.01347 11.5637L12.8308 17H17M4.68047 3.91111H6.57747L15.3102 16.1337H13.4127"
        fill="#5371AC"
      />
    </svg>
  );
}
